export const environment = {
  production: false,
  environmentName: 'DEV',
  // apiUrl: 'https://apim-br.devtest.aws.scania.com/upsprint-api/v1/api/'
  apiUrl: 'https://acp-upsprint-api.br.scania.com/api/'
  // apiUrl: 'http://localhost:8080/api/'
};
